import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element. Make sure your HTML file has a <div id="root"></div> element.');
}
const root = createRoot(rootElement);
root.render(<App data-id="element-0" />);